import React from "react";
import { ArrowLeftIcon, ArrowUpRightIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { SiteFooter } from "../components/SiteFooter";
const flexMlsUrl = "http://link.flexmls.com/1z74lszlgxjo,15";
export function CurrentListings() {
  return <main className="flex min-h-screen w-full flex-col bg-amber-950 text-amber-50" data-id="element-60" data-mp="38fr2bhj33kfw">
      <section className="flex flex-1 items-center px-6 py-16 sm:px-10 lg:px-14" data-id="element-61" data-mp="38hu04nqhahv6">
        <div className="mx-auto w-full max-w-3xl" data-id="element-62" data-mp="2kqgbarrjd4ey">
          <Link to="/mls-listings" className="inline-flex items-center gap-2 text-sm font-bold text-amber-100 transition-[color] duration-200 hover:text-white" data-id="element-63" data-mp="2gp32c8t5cl3t">
            <ArrowLeftIcon size={17} aria-hidden="true" data-id="element-64" data-mp="2poq7n5ozyb25" />
            Back to MLS options
          </Link>
          <p className="mt-16 text-xs font-bold uppercase tracking-[0.18em] text-amber-300" data-id="element-65" data-mp="9xc2n3el8zro">Teri Tangora Britton</p>
          <h1 className="mt-5 font-display text-5xl leading-[0.92] sm:text-7xl" data-id="element-66" data-mp="4xz77u9nikdh">Teri&apos;s current listings.</h1>
          <p className="mt-7 max-w-xl text-lg leading-8 text-amber-100" data-id="element-67" data-mp="2lab85k0rdu0s">
            Explore homes currently represented by Teri, then reach out to learn more or arrange a private showing.
          </p>
          <a href={flexMlsUrl} target="_blank" rel="noreferrer" className="mt-10 inline-flex items-center gap-3 rounded-md bg-amber-200 px-5 py-3.5 text-sm font-bold text-stone-950 transition-[background-color] duration-200 hover:bg-amber-100" data-id="element-68" data-mp="2v9jym2wf0qie">
            View current listings
            <ArrowUpRightIcon size={17} aria-hidden="true" data-id="element-69" data-mp="2cij3jpyf1f44" />
          </a>
        </div>
      </section>
      <SiteFooter tone="warm" data-id="element-70" data-mp="2h99a36ikvo0e" />
    </main>;
}